import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=25927b9f&scoped=true&"
import script from "./Activities.vue?vue&type=script&lang=js&"
export * from "./Activities.vue?vue&type=script&lang=js&"
import style0 from "./Activities.vue?vue&type=style&index=0&id=25927b9f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25927b9f",
  null
  
)

component.options.__file = "Activities.vue"
export default component.exports